import { Datagrid, DateField, EditButton, List, TextField } from "react-admin";




export function EventList(props) {

    return (
        <List {...props} >
            <Datagrid rowClick="show"  >
                <TextField source="name" />
                <DateField source="startDate" />
                <DateField source="endDate" />
                <TextField source="location" label="Location Link / Meeting Link" />
                <TextField  source="externalLink"/>
                <TextField  source="city"/>
                <TextField source="type" />
                <EditButton />

            </Datagrid>
        </List>
    )
}